module.exports = __webpack_public_path__ + "static/media/check-with-green-circle.38dd3512.svg";